import request from '@/utils/request'

export default {
  namespace: 'common',
  state: {
    cl: 'newweb_baofeng',
    navList: [],
    updateProfile: false, // 购买成功更新个人中心
    showBuyVip: false, // 展示vip购买框
    isLogin: false, // 是否登录
    openLoginModal: false, //  是否打开登录框
    searchList: [] // 搜索结果
  },
  mutations: {
    save (state, payload = {}) {
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    },

    // 展示vip购买框
    showVipModal (state, paylod) {
      state['showBuyVip'] = paylod.open
    },

    // 登录状态同步 是否登录
    syncLoginData (state, paylod) {
      state['isLogin'] = paylod.loginStatus
    },

    // 购买成功更新交易中心信息
    syncProfile (state, paylod) {
      state['updateProfile'] = paylod
    },

    // isopen
    isOpenLoginModal (state, paylod) {
      state['openLoginModal'] = paylod
    }
  },
  actions: {
    // 校验图形验证码
    async testCaptcha ({ commit }, payload) {
      const data = await request({
        url: '/pcap/v1/cap/valid',
        method: 'post',
        data: payload
      })
      return data || {}
    },

    // 发送手机验证码
    async sendPhoneCode ({ commit }, payload) {
      const data = await request({
        url: '/puser/user/sendsmscode',
        method: 'POST',
        data: payload
      })
      return data || {}
    },

    // 获取用户信息 和 vip 状态
    async getUserData ({ commit }, payload) {
      const data = await Promise.all([
        request.get('/pvip/v1/vip/userinfo', {params: payload.userinfo}),
        request.get('/puser/user/getuserinfo', {params: payload.getuserinfo})
      ])
      return data || []
    },

    // 密码登录
    async pwdLogin ({commit}, payload) {
      const data = await request({
        url: '/puser/user/login',
        method: 'post',
        data: payload
      })
      return data || {}
    },

    // 手机注册接口
    async phoneRegister ({commit}, payload) {
      const data = await request({
        url: '/puser/user/phone/register',
        method: 'post',
        data: payload
      })
      return data || {}
    },

    // 校验手机是否已经注册
    async userIsRegister ({commit}, payload) {
      const data = await request({
        url: '/puser/user/username/isavailable',
        method: 'post',
        data: payload
      })
      return data || {}
    },

    // 忘记密码 先获取短信的key
    async getPhoneKey ({commit}, payload) {
      const data = await request({
        url: '/puser/user/setpasswordbyphone',
        method: 'post',
        data: payload
      })
      return data || {}
    },

    // 重置密码接口
    async resetPassword ({commit}, payload) {
      const data = await request({
        url: '/puser/user/resetpassword',
        method: 'post',
        data: payload
      })
      return data || {}
    },

    // 登录
    async handleLogin ({ commit }, payload) {
      const data = await request({
        url: '/puser/user/phone/login',
        method: 'get',
        params: payload
      })
      return data || {}
    },

    // 退出登录
    async handleLogout ({ commit }, payload) {
      const data = await request({
        url: '/puser/user/logout',
        method: 'get',
        params: payload
      })
      return data || {}
    },

    // 获取列表
    async get_channel ({ commit, state }) {
      const data = await request({
        url: '/po/v7/config/channel',
        method: 'get',
        params: {
          cl: state.cl
        }
      })
      if (data && data.channels) {
        commit('save', {
          navList: data.channels
        })
      }
    },

    // 获取会员套餐列表 ctype 必选
    async vipList ({ commit }, payload) {
      const data = await request({
        url: '/pvip/v1/vip/payment',
        method: 'get',
        params: payload
      })
      return data || {}
    },

    // 获取预下单二维码
    async preorder ({commit}, payload) {
      const data = await request({
        url: '/pvip/v1/mergepay/preorder',
        method: 'get',
        params: payload
      })
      return data || {}
    },

    // 检查订单状态接口
    async orderstatus ({commit}, payload) {
      const data = await request({
        url: '/pvip/v1/mergepay/orderstatus',
        method: 'get',
        params: payload
      })
      return data || {}
    },

    // 查询用户订单列表接口
    async orderlist ({commit}, payload) {
      const data = await request({
        url: '/pvip/v1/vip/orderlist',
        method: 'get',
        params: payload
      })
      return data || {}
    },

    // 获取搜索热词接口
    async hotwordlist ({commit}, payload) {
      const data = await request({
        url: '/ps/v6/search/hotword',
        method: 'get',
        params: payload
      })
      return data || {}
    },

    // 获取搜索提示词接口
    async suggestionlist ({commit}, payload) {
      const data = await request({
        url: '/ps/v6/search/suggestions',
        method: 'get',
        params: payload
      })
      return data || {}
    },

    // 获取搜索结果接口
    async searchmedia ({commit}, payload) {
      const data = await request({
        url: '/ps/v6/search/media',
        method: 'get',
        params: payload
      })
      if (data && data.medias) {
        commit('save', {
          searchList: data
        })
      }
      console.log('commom.js--data:', data)
      return data || {}
    },
    // 电视剧展开集数
    async openepisode ({commit}, payload) {
      const data = await request({
        url: '/pm/v5/media/episode',
        method: 'get',
        params: payload
      })
      return data || {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/model/common.js